var $57664b33f789f815$exports = {};
$57664b33f789f815$exports = {
    "(optional)": `(op\u{163}ional)`,
    "(required)": `(obligatoriu)`
};


export {$57664b33f789f815$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
